import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BillingChargeType, ClaimState, IClientBillingClaim, PaymentStatus } from '../models/client-billing-claim.model';

// TODO: MER-4617 — replace stub with real HttpClient call to GET /svcs/billing/client_billing_claims
@Injectable({ providedIn: 'root' })
export class SessionHistoryHttpService {
  getClaims(): Observable<IClientBillingClaim[]> {
    return of(STUB_CLAIMS);
  }
}

const STUB_CLAIMS: IClientBillingClaim[] = [
  {
    id: 'claim-001',
    superBillId: 'sb-001',
    personaClientId: 12345,
    sessionDate: new Date('2026-02-14'),
    providerName: 'Marla Watts',
    primaryInsuranceName: 'United Healthcare',
    secondaryInsuranceName: 'Rocky Mountain Health Plan',
    claimState: ClaimState.PROCESSED,
    chargeType: BillingChargeType.COPAY,
    isCovered: false,
    amountBilled: 215.00,
    insurancePaid: 195.00,
    patientResponsibility: 20.00,
    copayLabel: 'Copay',
    denialReason: null,
    cptCodes: ['90837 - Follow up session (video)', '90785 - Interactive complexity'],
    paymentStatus: PaymentStatus.UPCOMING,
    paymentMethodBrand: 'VISA',
    paymentMethodLast4: '8635',
    accountPaymentMethodId: 'pm-001',
    scheduledPaymentDate: new Date('2026-03-06'),
    claimSubmittedAt: new Date('2026-02-20'),
    partOfPaymentPlan: false,
  },
  {
    id: 'claim-002',
    superBillId: 'sb-002',
    personaClientId: 12345,
    sessionDate: new Date('2026-01-10'),
    providerName: 'Marla Watts',
    primaryInsuranceName: 'United Healthcare',
    secondaryInsuranceName: null,
    claimState: ClaimState.COVERED,
    chargeType: BillingChargeType.COPAY,
    isCovered: false,
    amountBilled: 215.00,
    insurancePaid: 195.00,
    patientResponsibility: 20.00,
    copayLabel: 'Copay',
    denialReason: null,
    cptCodes: ['90837 - Follow up session (video)'],
    paymentStatus: PaymentStatus.PAID,
    paymentMethodBrand: 'VISA',
    paymentMethodLast4: '8635',
    accountPaymentMethodId: 'pm-001',
    scheduledPaymentDate: null,
    claimSubmittedAt: new Date('2026-01-15'),
    partOfPaymentPlan: false,
  },
  {
    id: 'claim-003',
    superBillId: 'sb-003',
    personaClientId: 12345,
    sessionDate: new Date('2025-12-20'),
    providerName: 'Marla Watts',
    primaryInsuranceName: 'United Healthcare',
    secondaryInsuranceName: null,
    claimState: ClaimState.PENDING,
    chargeType: BillingChargeType.PENDING_CLAIM,
    isCovered: false,
    amountBilled: 215.00,
    insurancePaid: 0,
    patientResponsibility: 0,
    copayLabel: null,
    denialReason: null,
    cptCodes: ['90837 - Follow up session (video)'],
    paymentStatus: null,
    paymentMethodBrand: null,
    paymentMethodLast4: null,
    accountPaymentMethodId: null,
    scheduledPaymentDate: null,
    claimSubmittedAt: new Date('2025-12-22'),
    partOfPaymentPlan: false,
  },
  {
    id: 'claim-004',
    superBillId: 'sb-004',
    personaClientId: 12345,
    sessionDate: new Date('2025-11-15'),
    providerName: 'Marla Watts',
    primaryInsuranceName: '',
    secondaryInsuranceName: null,
    claimState: ClaimState.COVERED,
    chargeType: BillingChargeType.EAP,
    isCovered: true,
    amountBilled: 215.00,
    insurancePaid: 215.00,
    patientResponsibility: 0,
    copayLabel: null,
    denialReason: null,
    cptCodes: ['90837 - Follow up session (video)'],
    paymentStatus: PaymentStatus.PAID,
    paymentMethodBrand: null,
    paymentMethodLast4: null,
    accountPaymentMethodId: null,
    scheduledPaymentDate: null,
    claimSubmittedAt: new Date('2025-11-18'),
    partOfPaymentPlan: false,
  },
  {
    id: 'claim-005',
    superBillId: 'sb-005',
    personaClientId: 12345,
    sessionDate: new Date('2025-10-05'),
    providerName: 'Marla Watts',
    primaryInsuranceName: 'United Healthcare',
    secondaryInsuranceName: null,
    claimState: ClaimState.PAST_DUE,
    chargeType: BillingChargeType.CLAIM_DENIED,
    isCovered: false,
    amountBilled: 215.00,
    insurancePaid: 0,
    patientResponsibility: 215.00,
    copayLabel: null,
    denialReason: null,
    cptCodes: ['90837 - Follow up session (video)'],
    paymentStatus: PaymentStatus.PAST_DUE,
    paymentMethodBrand: 'VISA',
    paymentMethodLast4: '8635',
    accountPaymentMethodId: 'pm-001',
    scheduledPaymentDate: null,
    claimSubmittedAt: new Date('2025-10-08'),
    partOfPaymentPlan: false,
  },
];
